import { useEffect, useState } from "react";
import { DatePicker, Form, Row, Col } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import "dayjs/locale/ar";

const CustomDatePicker = ({ onChange }: { onChange: any }) => {
    const [year, setYear] = useState<number | null>(null);
    const [month, setMonth] = useState<number | null>(null);
    const [day, setDay] = useState<number | null>(null);
    const { t, i18n } = useTranslation();

    const handleYearChange = (date: Dayjs | null) => {
        setYear(date ? date.year() : null);
        // setMonth(null);
        // setDay(null);
    };
    function isSelectedDayInMonth(month: number | null) {
        if (month === null || !day) {
            return true;
        }
        const daysInMonth = dayjs(`${month}`, "M").daysInMonth();
        return day < daysInMonth;
    }
    const handleMonthChange = (date: Dayjs | null): boolean => {
        const updatedMonth = date ? date.month() + 1 : null;
        let isDayUpdated = false;
        if (!isSelectedDayInMonth(updatedMonth)) {
            setDay(null);
            isDayUpdated = true;
        }
        setMonth(updatedMonth);
        return isDayUpdated;
        // setDay(null);
    };

    const handleDayChange = (date: Dayjs | null) => {
        setDay(date ? date.date() : null);
    };

    const disabledMonth = (currentMonth: number) => {
        const currentYear = dayjs().year();
        if (year === currentYear) {
            return currentMonth > dayjs().month();
        }
        return false;
    };
    const disabledDay = (currentDay: number) => {
        const daysInMonth = dayjs(`${year ?? dayjs().year()}-${month ?? 1}`, "YYYY-M").daysInMonth();
        return currentDay > daysInMonth;
    };
    function onDateChange(date: Dayjs | null, type: "year" | "month" | "day") {
        let updatedYear = type === "year" ? date?.year() : year;
        let updatedMonth = type === "month" && date ? date?.month() + 1 : month;
        let updatedDay = type === "day" ? date?.date() : day;

        switch (type) {
            case "year":
                handleYearChange(date);
                break;
            case "month":
                const isDayUpdate = handleMonthChange(date);
                if (isDayUpdate) {
                    updatedDay = null;
                }
                break;
            case "day":
                handleDayChange(date);
                break;
        }

        if (updatedYear && updatedMonth && updatedDay) {
            const fullDate = dayjs(`${updatedYear}-${updatedMonth}-${updatedDay}`, "YYYY-M-D");
            if (fullDate.isValid()) {
                onChange(fullDate.format("YYYY-MM-DD"));
            } else {
                onChange(undefined);
            }
        } else {
            onChange(undefined);
        }
    }
    useEffect(() => {
        dayjs.locale(i18n.language);
    }, [i18n.language]);
    return (
        <Form.Item
            name={"date_of_birth"}
            label={t("Birthdate")}
            rules={[{ required: true, message: t("Birthdate is required") }]}
        >
            <Row gutter={16}>
                <Col span={8}>
                    <DatePicker
                        className="Custom_Form_Date_picker"
                        placeholder={t("Day")}
                        defaultPickerValue={dayjs(`${year ?? dayjs().year()}-${month ?? 1}`, "YYYY-M")}
                        onChange={(date) => onDateChange(date, "day")}
                        value={day ? dayjs(`${year ?? dayjs().year()}-${month ?? 1}-${day}`, "YYYY-M-D") : null}
                        format="DD"
                        disabledDate={(current) => disabledDay(current.date())}
                        inputReadOnly
                        showNow={false}
                        allowClear={false}
                        popupClassName="without-controls-date-picker"
                    />
                </Col>
                <Col span={8}>
                    <DatePicker
                        className="Custom_Form_Date_picker"
                        placeholder={t("Month")}
                        picker="month"
                        mode="month"
                        onChange={(date) => onDateChange(date, "month")}
                        value={month ? dayjs(`${year ?? dayjs().year()}-${month}`, "YYYY-M") : null}
                        defaultPickerValue={year ? dayjs(`${year}`, "YYYY") : undefined}
                        disabledDate={(current) => disabledMonth(current.month())}
                        inputReadOnly
                        format={`MMMM`}
                        allowClear={false}
                    />
                </Col>
                <Col span={8}>
                    <DatePicker
                        className="Custom_Form_Date_picker"
                        placeholder={t("Year")}
                        picker="year"
                        onChange={(date) => onDateChange(date, "year")}
                        value={year ? dayjs(`${year}`, "YYYY") : null}
                        inputReadOnly
                        allowClear={false}
                    />
                </Col>
            </Row>
        </Form.Item>
    );
};

export default CustomDatePicker;
